<template>
	<div style="padding: 10px 0;">
		<div style="border: 1px solid #e8e8e8; padding: 12px; border-radius: 4px; position: relative;">
			<a-form layout="inline" style="margin-bottom: 8px;">
				<a-form-item label="VR地址" :validate-status="urlError ? 'error' : ''" :help="urlError || ''">
					<a-input v-model="vrUrl" placeholder="请输入VR地址" style="width: 400px" @input="syncParent" @blur="validateUrl" />
				</a-form-item>
			</a-form>
			<a-form layout="inline">
				<a-form-item label="VR状态">
					<a-switch :checked="vrStatus" @change="onChange" />
					<span style="margin-left: 8px; color: #666;">{{ vrStatus ? '启用' : '停用' }}</span>
				</a-form-item>
			</a-form>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Object,
				default: () => ({
					vrUrl: '',
					vrStatus: false
				})
			}
		},
		data() {
			return {
				vrUrl: this.value.vrUrl || '',
				vrStatus: this.value.vrStatus || false,
				urlError: ''
			}
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler(val) {
					if (val) {
						this.vrUrl = val.vrUrl || '';
						this.vrStatus = val.vrStatus || false;
					}
				}
			}
		},
		methods: {
			validateUrl() {
				if (!this.vrUrl) {
					this.urlError = '';
					return true;
				}
				const pattern = /^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w\-.\/?%&=]*)?$/;
				if (!pattern.test(this.vrUrl)) {
					this.urlError = '请输入正确的URL地址（以http://或https://开头）';
					return false;
				} else {
					this.urlError = '';
					return true;
				}
			},
			validate() {
				const valid = this.validateUrl();
				if (!valid) {
					this.$message.warning('请输入正确的URL地址（以http://或https://开头）');
				}
				return valid;
			},
			syncParent() {
				this.$emit('input', {
					vrUrl: this.vrUrl,
					vrStatus: this.vrStatus
				});
			},
			onChange(v) {
				this.vrStatus = v;
				this.$emit('input', {
					vrUrl: this.vrUrl,
					vrStatus: v
				});
			}
		}
	};
</script>
